import { render, staticRenderFns } from "./b-single-select.vue?vue&type=template&id=bd8f655c&scoped=true"
import script from "./b-single-select.vue?vue&type=script&lang=js"
export * from "./b-single-select.vue?vue&type=script&lang=js"
import style0 from "./b-single-select.vue?vue&type=style&index=0&id=bd8f655c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f655c",
  null
  
)

export default component.exports